import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

import { api } from "../../../config";
import defaultImg from "../../../assets/images/upload.png";

//Import actions
import { resetAssetInspectionCategoryState, getAssetInspectionCategory } from "../../../store/assetInspectionCategory/action";
import { resetFollowupListState, getFollowupList } from "../../../store/followupList/action";
import { resetAssetState, getAsset } from "../../../store/asset/action";
import { getAssetInspection as onGetAssetInspections, addNewAssetInspection as onAddNewAssetInspection, updateAssetInspection as onUpdateAssetInspection, deleteAssetInspection as onDeleteAssetInspection, getAssetInspectionLoading, resetAssetInspectionState } from "../../../store/assetInspection/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ModalInputFile from "../../../Components/ModalInputFile";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const AssetInspection = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clientLoading, clients, assetInspections, isAssetInspectionCreated, isAssetInspectionSuccess, loading, followupLists, followupListLoading, error, companies, companyLoading, assets, assetLoading, assetInspectionCategories, assetInspectionCategoryLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    assetInspections: state.AssetInspection.assetInspections,
    isAssetInspectionCreated: state.AssetInspection.isAssetInspectionCreated,
    isAssetInspectionSuccess: state.AssetInspection.isAssetInspectionSuccess,
    loading: state.AssetInspection.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.AssetInspection.error,
    assets: state.Asset.assets,
    assetLoading: state.Asset.loading,
    followupLists: state.FollowupList.followupLists,
    followupListLoading: state.FollowupList.loading,
    assetInspectionCategories: state.AssetInspectionCategory.assetInspectionCategories,
    assetInspectionCategoryLoading: state.AssetInspectionCategory.loading,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [assetInspectionList, setAssetInspectionList] = useState([]);
  const [assetInspection, setAssetInspection] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [assetInspectionDetail, setAssetInspectionDetail] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [assetList, setAssetList] = useState([]);
  const [companyName, setCompanyName] = useState({});
  const [logo, setLogo] = useState(defaultImg);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [otherDocImg, setOtherDocImg] = useState([]);
  const [modalMedia, setModalMedia] = useState(false);
  const [originalFiles, setOriginalFiles] = useState([]);
  const [checkFollowupList, setCheckFollowupList] = useState([]);
  const [assetInspectionCategoryList, setAssetInspectionCategoryList] = useState([]);
  const ref = useRef(null);

  const [assetMessage, setAssetMessage] = useState("");

  const onClickDelete = (assetInspection) => {
    setAssetInspection(assetInspection);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (assetInspectionDetail) => {
    setAssetInspectionDetail(assetInspectionDetail);
    setDeleteModalDetail(true);
  };

  const handleDeleteAssetInspection = () => {
    if (assetInspection) {
      dispatch(onDeleteAssetInspection(assetInspection));
      setDeleteModal(false);
    }
  };

  const onClickApprove = (employee) => {
    setAssetInspection(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredAssetInspections = assetInspections;
      if (type !== "all") {
        filteredAssetInspections = assetInspections.filter((assetInspection) => assetInspection.asset_inspection_status.name === type);
      }
      setAssetInspectionList(filteredAssetInspections);
    }
  };

  const statusActiveData = [
    {
      options: [
        { label: "OPEN", value: "1" },
        { label: "PROCESSED", value: "2" },
        { label: "CLOSED", value: "3" },
      ],
    },
  ];

  useEffect(() => {
    setAssetMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user.user_asset && userData?.user.user_asset.name}`);
    dispatch(resetAssetInspectionState());
    dispatch(onGetAssetInspections());
    dispatch(resetAssetInspectionCategoryState());
    dispatch(getAssetInspectionCategory());
    handleGetAsset(userData?.companyId);
    handleGetFollowupList(userData?.companyId);
  }, []);

  const handleGetFollowupList = (id) => {
    dispatch(resetFollowupListState());
    dispatch(getFollowupList({ companyId: id, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(assetInspections)) {
      setIsEdit(false);
      let filteredAssetInspections = assetInspections;
      if (activeTypeTab !== "all") {
        filteredAssetInspections = assetInspections.filter((assetInspection) => assetInspection.asset_inspection_status.name === activeTypeTab);
      }
      setAssetInspectionList(filteredAssetInspections);
      let current = 0;
      setInfo(assetInspections[current]);
    }
  }, [assetInspections]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(assetInspectionCategories)) {
      var data = [];
      var opt = [];
      assetInspectionCategories.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAssetInspectionCategoryList(data);
    }
  }, [assetInspectionCategories]);

  useEffect(() => {
    var data = [];
    var opt = [];
    assets.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      const departmentId = item.departmentId;
      var obj = { label: name, value: id, departmentId: departmentId };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (assets.length > 0) {
      setAssetList(data);
    }
  }, [assets]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleSelectFile = (file) => {
    setOtherDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = otherDocImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setOtherDocImg(newState);
    } else {
      const index = otherDocImg.findIndex((fl) => fl.filename === file.filename);
      setOtherDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setOriginalFiles([]);
      setOtherDocImg([]);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleAssetInspectionClick = useCallback(
    (arg) => {
      const data = arg;

      let files = [];

      if (data.asset_inspection_file.length > 0) {
        data.asset_inspection_file.forEach((element) => {
          files.push({
            filename: element.filename,
          });
        });
      }

      setOtherDocImg(files);
      let arrFeedback = [];
      if (data.feedback && data.feedback.length > 0) {
        for (const d of data.feedback) {
          arrFeedback.push(d);
        }
      } else {
        for (const d of followupLists) arrFeedback.push({ id: 0, name: d.name, actualat: "", description: "" });
      }
      setCheckFollowupList(arrFeedback);
      setAssetInspection({
        id: data.id,
        name: data.name,
        description: data.description,
        feedback: data.arrFollowup,
        client: data.asset_inspection_client && {
          label: data.asset_inspection_client ? data.asset_inspection_client.name : "",
          value: data.asset_inspection_client ? data.asset_inspection_client.id : "",
        },
        company: data.asset_inspection_company && {
          label: data.asset_inspection_company ? data.asset_inspection_company.name : "",
          value: data.asset_inspection_company ? data.asset_inspection_company.id : "",
        },
        asset: data.asset_inspection_asset && {
          label: data.asset_inspection_asset ? data.asset_inspection_asset.name : "",
          value: data.asset_inspection_asset ? data.asset_inspection_asset.id : "",
        },
        status: data.asset_inspection_status && {
          label: data.asset_inspection_status ? data.asset_inspection_status.name : "",
          value: data.asset_inspection_status ? data.asset_inspection_status.id : "",
        },
        category: data.asset_inspection_category && {
          label: data.asset_inspection_category ? data.asset_inspection_category.name : "",
          value: data.asset_inspection_category ? data.asset_inspection_category.id : "",
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="warning"
                    className={`btn-sm ${userType === "admin" || userType === "client" || userType === "company" || (userRole && userRole.split(",").includes("updateAssetInspection")) ? "" : "d-none"}`}
                    onClick={() => {
                      handleAssetInspectionClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="info"
                    className={`btn-sm ${userType === "admin" || userType === "client" || userType === "company" || (userRole && userRole.split(",").includes("deleteAssetInspection")) ? "" : "d-none"}`}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    Set Sudah Closed
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Data Aset",
        accessor: "asset_inspection_asset.name",
        filterable: true,
        Cell: (cell) => <span>{cell.row.original.asset_inspection_asset ? cell.row.original.asset_inspection_asset.name : "-"}</span>,
      },
      {
        Header: "Temuan Masalah",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Kategori Temuan",
        accessor: "asset_inspection_category.name",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: `Status`,
        accessor: "asset_inspection_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">OPEN</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">PROCESSED</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">CLOSED</span>;
          }
        },
      },
    ],
    [handleAssetInspectionClick, userType, userRole]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: assetInspectionList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (assetInspection && assetInspection.name) ?? "",
      client: (assetInspection && assetInspection.client) || clientSelected,
      company: (assetInspection && assetInspection.company) || companySelected,
      asset: assetInspection && assetInspection.asset,
      status: assetInspection && assetInspection.status,
      feedback: (assetInspection && assetInspection.feedback) ?? "",
      description: (assetInspection && assetInspection.description) ?? "",
      file: (assetInspection && assetInspection.file) || [],
      category: (assetInspection && assetInspection.category) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Silahkan isi temuan masalah").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getAssetInspectionLoading());
      if (isEdit) {
        const updateAssetInspection = {
          id: assetInspection ? assetInspection.id : 0,
          name: values.name,
          description: values.description,
          assetId: values.asset ? values.asset.value : null,
          assetInspectionCategoryId: values.category.value,
          clientId: values.client.value,
          companyId: values.company.value,
          feedback: values.feedback,
          statusId: values.status.value,
          files: otherDocImg.length > 0 ? otherDocImg : [],
        };
        dispatch(onUpdateAssetInspection(updateAssetInspection));
        validation.resetForm();
      } else {
        const newAssetInspection = {
          name: values.name,
          description: values.description,
          assetId: values.asset ? values.asset.value : null,
          assetInspectionCategoryId: values.category.value,
          clientId: values.client.value,
          companyId: values.company.value,
          feedback: values.feedback,
          statusId: values.status.value,
          files: otherDocImg.length > 0 ? otherDocImg : [],
        };
        dispatch(onAddNewAssetInspection(newAssetInspection));
        validation.resetForm();
      }
      toggle();
    },
  });

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetAssetInspections(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setAssetInspectionList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    dispatch(resetAssetInspectionState());
    dispatch(onGetAssetInspections());
  };

  const handleGetAsset = (id) => {
    dispatch(resetAssetState());
    dispatch(getAsset({ companyId: id }));
  };

  useEffect(() => {
    setAssetList([]);
    return () => {
      dispatch(resetAssetState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  document.title = "Inspeksi Aset | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAssetInspection} onCloseClick={() => setDeleteModal(false)} />
      <Container fluid>
        <BreadCrumb title="Aset" pageTitle="Inspeksi Aset">
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createAssetInspection") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-coupon-line me-1 align-bottom fs-14"></i> Tambah
            </button>
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Data Inspeksi Aset &nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-coupon-line me-1 align-bottom fs-14"></i> SEMUA INSPEKSI ASET
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> OPEN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> PROCESSED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> CLOSED
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={9}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Temuan Aset" : "Tambah Temuan Aset"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-4">
                          <div className="mb-3 ">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setBranchSelect(null));
                                dispatch(setCompanySelect(e));
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="asset-field" className="form-label">
                              Asset Bermasalah&nbsp;
                              {assetLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="asset"
                              value={validation.values.asset}
                              placeholder="Pilih Aset"
                              onChange={(e) => {
                                validation.setFieldValue("asset", e);
                              }}
                              options={assetList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="category-field" className="form-label">
                              Kategori Temuan &nbsp;
                              {assetInspectionCategoryLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="category"
                              value={validation.values.category}
                              placeholder="Pilih Kategori"
                              onChange={(e) => {
                                validation.setFieldValue("category", e);
                              }}
                              options={assetInspectionCategoryList}
                            ></Select>
                          </div>
                        </div>
                        <div className="mb-3 col-lg-8">
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Temuan Masalah
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Temuan Masalah" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="education" className="form-label">
                              Bukti (Jika ada)
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {otherDocImg.map((otherDocFile, i) => {
                            if (otherDocFile.isDeleted) {
                              return null;
                            } else {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      <img src={otherDocFile.filename === "" ? logo : `${api.MEDIA_URL}/media/${otherDocFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                    </div>
                                    <div className="text-truncate">{otherDocFile.originalname}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          handleDeleteFile(otherDocFile);
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                          <div className="mb-3">
                            <Label htmlFor="status-field" className="form-label">
                              Status
                            </Label>
                            <Select
                              name="status"
                              value={validation.values.status}
                              placeholder="Pilih Status"
                              onChange={(e) => {
                                validation.setFieldValue("status", e);
                              }}
                              options={statusActiveData}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="description-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="description-field" rows="7" className="form-control" placeholder="Uraian Inspeksi Aset" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description} />
                          </div>

                          {followupLists.map((o, idx) => {
                            return (
                              <div key={idx} className="row ms-1">
                                <div className="form-check form-switch form-switch-custom form-switch-success mb-2 col-lg-5">
                                  <Input
                                    className={"form-check-input checked-all checked-method-all check-" + o.id + idx}
                                    type="checkbox"
                                    role="switch"
                                    value={validation.values.feedback[idx]?.id}
                                    defaultChecked={o.id === validation.values.feedback[idx]?.id && validation.values.feedback[idx]?.id !== 0 ? true : false}
                                    onChange={(e) => {
                                      if (e.target.checked) validation.setFieldValue(`feedback[${idx}].id`, o.id);
                                      else validation.setFieldValue(`feedback[${idx}].id`, 0);
                                    }}
                                  />
                                  <Label className="form-check-label text-dark text-uppercase fs-12" htmlFor={"check-" + o.id + idx}>
                                    {o.name}
                                  </Label>
                                </div>
                                <div className="mb-2 col-lg-2">
                                  <Flatpickr
                                    className="form-control"
                                    placeholder="Actual"
                                    options={{ mode: "single", dateFormat: "Y/m/d" }}
                                    onChange={(selectedDates, dateStr) => {
                                      if (validation.values.feedback[idx]) validation.values.feedback[idx].actualat = dateStr;
                                    }}
                                    value={validation.values.feedback[idx]?.actualat}
                                  />
                                </div>
                                <div className="mb-2 col-lg-5">
                                  <Input
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Keterangan jika ada"
                                    value={validation.values.feedback[idx]?.description}
                                    onChange={(e) => {
                                      validation.setFieldValue(`feedback[${idx}].description`, e.target.value);
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AssetInspection;
